import { render, staticRenderFns } from "./TalkRightPane.vue?vue&type=template&id=505789c5&scoped=true"
import script from "./TalkRightPane.vue?vue&type=script&lang=js"
export * from "./TalkRightPane.vue?vue&type=script&lang=js"
import style0 from "./TalkRightPane.vue?vue&type=style&index=0&id=505789c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505789c5",
  null
  
)

export default component.exports